import API from "../BaseURL";

const config = {
  headers: {
    "content-type": "application/x-www-form-urlencoded",
  },
};

const configJson = {
  headers: {
    "content-type": "application/json",
  },
};


export async function getAllClientsReduced() {
  const res = API.get(`/users/users/`, configJson);
  return res;
}

export async function getAllClients() {
  const res = API.get(`/users/users/alldata`, configJson);
  return res;
}

export async function getRoles() {
  const res = API.get(`/roles/roles/`, configJson);
  return res;
}


export async function getDomainsByManager(user_id) {
  if (!user_id) {
    return;
  }
  const res = API.get(`/users/users/${user_id}/domains`, configJson);
  return res;
}


export async function getExploitationsByManager(user_id) {
  if (!user_id) {
    return;
  }
  const res = API.get(`/users/users/${user_id}/exploitations`, configJson);
  return res;
}

export async function getClientInfo(user_id) {
  if (!user_id) {
    return;
  }
  const res = API.get(`/users/users/${user_id}/data`, configJson);
  return res;
}

export async function createClient(data) {
  const res = API.post(`/users/users/`, data, configJson);
  return res;
}

export async function updateClient(user_id, data) {
  const res = API.put(`/users/users/${user_id}/`, data, configJson);
  return res;
}

export async function deleteClient(user_id) {
  const res = API.delete(`/users/users/${user_id}/`, configJson);
  return res;
}
